import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MenuHorizontal = _resolveComponent("MenuHorizontal")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_FooterPagina = _resolveComponent("FooterPagina")!
  const _component_WhatsappFlutuante = _resolveComponent("WhatsappFlutuante")!
  const _component_BarraAcaoMobile = _resolveComponent("BarraAcaoMobile")!
  const _component_BotaoTopo = _resolveComponent("BotaoTopo")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MenuHorizontal, {
      TextoWhatsApp: "Preciso de um eletricista!",
      temaEscuro: _ctx.temaEscuro,
      onAlternarTema: _ctx.alternarTema
    }, null, 8, ["temaEscuro", "onAlternarTema"]),
    _createVNode(_component_router_view),
    _createVNode(_component_FooterPagina, {
      LinkLinkedin: "https://www.linkedin.com/in/viniciusdeol/",
      LinkFacebook: "https://www.facebook.com/limatecbonitoms/",
      LinkInstagram: "https://www.instagram.com/limatec_bonito_ms/",
      Titulo: _ctx.copyright
    }, null, 8, ["Titulo"]),
    _createVNode(_component_WhatsappFlutuante, {
      ref: "chat",
      TextoWhatsApp: "Preciso de um eletricista!"
    }, null, 512),
    _createVNode(_component_BarraAcaoMobile, {
      onAbrirChat: _cache[0] || (_cache[0] = ($event: any) => (_ctx.abrirChat()))
    }),
    _createVNode(_component_BotaoTopo)
  ], 64))
}